exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gl_heading div,.gl_heading p{display:inline-block}.gl_heading div{text-align:right;font-weight:700;font-size:18px;float:right;margin-top:13px}.gl_heading div a{text-decoration:none;color:#000;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7c62d18","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./admin/assets/App.vue
// module id = 24
// module chunks = 0